module.exports = __webpack_public_path__ + "static/media/icon_mission_chapter.83bd9a8a.svg";